export default {
  // menu layout
  dashboard: "Dashboard",
  design: "Design",
  document: "Document",
  information: "Information",
  profile: "Profile",
  logout: "Logout",
  bandname: "Metropolitan Electricity Authority",
  user: "User",
  // design
  clear: "Clear",
  project: "Electrical design",
  proj: "Project",
  projReport: "Report projects",
  createProject: "Create Project",
  assign: "Assign",
  workOrderNo: "Work Order No.",
  customerName: "Customer Name",
  createDate: "Create Date",
  status: "Status",
  confirm: "Confirm",
  waitting: "Waitting",
  inProcess: "In Process",
  complete: "Completed",
  all: "All",
  search: "Search",
  rowPerPage: "Rows per page",
  noProject: "No Project !!",
  pleaseCreateProject: "Please create project for design electrical system.",
  required: "Required",
  department: "Department",
  detail: "Detail",
  customerAddress: "Customer Address",
  cancel: "Cancel",
  update: "Update",
  create: "Create",
  save: "Save",
  donotsave: "Don't Save",
  edit: "Edit",
  summary: "Summary",
  chooseEquip: "Choose Equipment",
  appearance: "Appearance",
  sendEmailReport: "Send email report",
  startDate: "Start date",
  endDate: "End Date",
  //equip electric
  pole: "Pole",
  cable: "Cable",
  relay: "Relay",
  transformer: "Transformer",
  switch: "Switch",
  meter: "Meter",
  riserTransformer: "Riser Transformer",
  cableType: "Cable Type",
  workFunction: "Work Function",
  comment: "Comment",
  images: "Images",
  chooseImage: "Choose image",
  lamp: "Lamp",
  size: "Size",
  ground: "Ground",
  type: "Type",
  heigh: "Heigh",
  metre: "meter",
  // electrict mapservice
  overhead: "Overhead",
  underground: "Underground",
  groupX: "On ground electrical system",
  groupY: "Underground electrical system",
  groupZ: "Fiber optic",
  groupA: "Public electrical system",
  Lowvoltagemeter: "Low voltage meter",
  HighTensionMeter: "High Tension Meter",
  GroupMeter: "Group Meter",
  Transformer: "Transformer",
  Switch: "Switch",
  Fuse: "Fuse",
  Capacitor: "Capacitor",
  CircuitBreaker: "Circuit Breaker",
  LightningArrestor: "Lightning Arrestor",
  InlineEquipment: "Inline Equipment",
  Ground: "Ground",
  SpanGuy: "Guy",
  Pole: "Pole",
  MeterLine: "Meter Line",
  Meter_Link: "Meter Link",
  OHHVConductor: "OHHV Conductor",
  OHMVConductor: "OHMV Conductor",
  OHLVConductor: "OHLV Conductor",
  OHLVConductorUnderBuilding: "OHLV Conductor Under Building",
  ManHole: "Manhole",
  Splice: "Splice",
  CCTV: "CCTV",
  FiberOpticCable: "Fiber Optic Cable",
  OHSLConductor: "OHSL Conductor",
  Streetlight: "Street light",
  StreetlightControl: "Street light Control",
  UGMVConductor: "UGMV Conductor",
  UGHVConductor: "UGHV Conductor",
  UGLVConductor: "UGLV Conductor",
  DuctBank: "Duct Bank",
  UGSLConductor: "UGSL Conductor",
  FiberOpticCable_MEA: "Fiber",
  SLInlineEquipment: "SL In line Equipment",
  // administrative boundary
  administrativeBoundary: "Administrative boundary",
  province: "Province",
  amphoe: "Amphoe",
  tambon: "Tambon",
  municipal: "Municipal",
  housing: "housing",
  // basemap
  basemap: "Base map",
  meaTile: "Landbase Map",
  nostra: "NOSTRA Map",
  meaOrtho: "Aerial photo",
  // print
  layout: "Layout",
  landscape: "Landscape",
  portrait: "Portrait",
  paperSize: "Paper size",
  scale: "Scale",
  other: "Other",
  compass: "Compass",
  overview: "Overview",
  grayscale: "Grayscale",
  estimator: "Estimator",
  examiner: "Examiner",
  head: "Head",
  divisionDirector: "Division director",
  districtDirector: "District director",
  print: "Print",
  preview: "Preview",
  //user
  name: "Name",
  lastname: "Lastname",
  organization: "Organization",
  address: "Address",
  phone: "Phone",
  register: "Register",
  back: "Back",
  district: "District",
  subdistrict: "Subdistrict",
  city: "City",
  country: "Country",
  zipcode: "Zip Code",
  sameemail: "อีเมลนี้ถูกใช้งานแล้ว",
  registersuccess:
    "Successfully registered. Please check your email to verify an account.",
  next: "Next",
  email: "E-mail",
  password: "Password",
  confirmpassword: "Confirm Password",
  passwordnotmatch: "password and confirm password not match.",
  personalinfo: "Personal Info",
  account: "Account",
  createAccessService: "Create an account and access to the service",
  alreadyaccount: "Already have an account yet",
  signin: "Sign in",
  bySignin: "By sign in, you agree to",
  and: "and",
  privacyPolicy: "Privacy Policy",
  termCondition: "Term & Condition",
  getmorething: "Get more things done with sign in service",
  donthaveaccount: "Dont have an account yet",
  createhere: "Create here",
  rememberme: "Remember me",
  forgotPassword: "Forgot Password",
  // confirm save
  confirmSavePrimary: "Do you want to save the changes made to",
  confirmSaveSecondary: "Your changes will be lost if you don't save them",
  //information
  gotohomepage: "Go to homepage",
  askforusage: "Ask for usage",
  mealist: "MEA register list",
  lastUpdate: "Last updated",
  // util
  duration: "Duration",
  custom: "Custom",
  month: "Month",
  monthly: "Monthly",
  quarter: "Quarter",
  quarterly: "Quarterly",
  year: "Year",
  yearly: "Yearly",
  noData: "No data",
  landmarkPoint: "Location",
  electricUser: "Electric user",
};
